export const en = {
  headingLine1: "Let's build something",
  headingAccent: "solid",
  headingSuffix: " together.",
  paragraph:
    "Open to freelance back-end and AI work. The fastest way to reach me is LinkedIn.",
  linkedinLabel: "LinkedIn",
};
